<template>
  <SkeletonBlock
    :is-active="isSkeletonActive"
    :width="width"
    :height="48"
  >
    <slot />
  </SkeletonBlock>
</template>

<script setup lang="ts">
  import { SkeletonBlock } from '@experience/core-skeleton-lib';
  import { useScreenSize } from '@experience/shared';
  import { useExcursionListingSkeleton } from '@/shared/composables/excursion/useExcursionDelayedListingSkeleton.ts';

  const { isMobile } = useScreenSize();

  const width = computed(() => {
    if (isMobile.value) {
      return '100%';
    }

    return 210;
  });

  const { isSkeletonActive } = useExcursionListingSkeleton();
</script>

<style lang="scss"></style>
